/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export enum PubSubEvents {
  RequestUnauthorized = 'RequestUnauthorized',
}

export interface PubSubEventsMapping {
  [PubSubEvents.RequestUnauthorized]: object;
}

export type PubSubEvent<T extends PubSubEvents> = {
  type: T;
  payload: PubSubEventsMapping[T];
};
